import React, { Component, useState, useRef, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import VendorHeader from "./../../component/VendorHeader";
import VendorFooter from "./../../component/VendorFooter";
import $ from "jquery";
import { API_BASE_URL } from "../../utils/app_url";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "../../component/Sidebar";
import { NotificationManager } from "react-notifications";

const LANGUAGES = [
    { code: "en", label: "English" },
    { code: "de", label: "German" },
    { code: "fr", label: "French" },
    { code: "it", label: "Italian" },
    { code: "es", label: "Spanish" },
    { code: "ru", label: "Russian" },
    { code: "tr", label: "Turkish" }
];

const EditAnnouncement = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const { id } = useParams();
    const { selectedLanguage, langJson } = useLanguage();

    const [translations, setTranslations] = useState({
        en: "",
        de: "",
        fr: "",
        it: "",
        es: "",
        ru: "",
        tr: ""
    });
    const [signupStatus, setSignupStatus] = useState("");
    const [loading, setLoading] = useState(false);
    const [addBtnDis, setAddBtnDis] = useState(false);

    const fetchAnnouncementDetails = async () => {
        try {
            setLoading(true);
            const response = await fetch(`${API_BASE_URL}stores/announcements/${id}`, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${user.authorisation.token}`,
                },
            });
            const responseData = await response.json();
            if (responseData.res === true) {
                const data = responseData.data;
                // Assuming the API returns translations object with language codes
                if (data.translations) {
                    setTranslations(data.translations);
                }
            } else {
                NotificationManager.warning(responseData.msg || "Failed to fetch announcement details");
            }
        } catch (error) {
            console.error("Error fetching announcement details:", error);
            NotificationManager.error("Failed to load announcement");
        } finally {
            setLoading(false);
        }
    };

    const handleTextChange = (lang, value) => {
        setTranslations(prev => ({
            ...prev,
            [lang]: value
        }));
    };

    const onUpdateAnnouncement = async () => {
        // Check if at least one language has text
        const hasAnyText = Object.values(translations).some(text => text && text.trim() !== "");

        if (!hasAnyText) {
            NotificationManager.warning(langJson?.textisrequired ?? "At least one language text is required");
            return;
        }

        setAddBtnDis(true);
        setSignupStatus("");
        setLoading(true);

        const fd = new FormData();
        // Send all translations
        LANGUAGES.forEach(lang => {
            fd.append(`translations[${lang.code}]`, translations[lang.code] || "");
        });
        fd.append("is_active", 1);

        try {
            const response = await fetch(`${API_BASE_URL}stores/announcements/${id}`, {
                method: "POST",
                body: fd,
                headers: {
                    Authorization: `Bearer ${user.authorisation.token}`,
                },
            });
            const responseData = await response.json();
            if (responseData.res === true) {
                setSignupStatus(responseData.msg);
                NotificationManager.success(responseData.msg);
                setLoading(false);
                setTimeout(() => {
                    navigate("/admin/announcements");
                }, 1000);
            } else {
                setSignupStatus(responseData.msg);
                NotificationManager.warning(responseData.msg);
                setLoading(false);
                setAddBtnDis(false);
            }
        } catch (error) {
            console.error("Error updating announcement:", error);
            setLoading(false);
            setAddBtnDis(false);
            setSignupStatus(langJson?.somethingwentwrong ?? "Something went wrong");
            NotificationManager.error(langJson?.somethingwentwrong ?? "Something went wrong");
        }
    };

    useEffect(() => {
        fetchAnnouncementDetails();
    }, [id]);

    useEffect(() => {
        $(".addProductForm .multiSelect").click(function () {
            $(this).find(".multiOpt").toggleClass("active");
        });
    }, []);

    return (
        <div>
            <div className="dashHeader">
                <VendorHeader />
            </div>
            <div className="adminDash">
                <Sidebar />
                <div className="rightSide">
                    <h2>{langJson?.editannouncement ?? 'Edit Announcement'}</h2>

                    {loading ? (
                        <p>{langJson?.pleasewait ?? "Loading..."}</p>
                    ) : (
                        <>
                            <div className="addProductForm">
                                <ul className="addAddress">
                                    {LANGUAGES.map((lang) => (
                                        <li key={lang.code}>
                                            <label>{lang.label} ({lang.code.toUpperCase()})</label>
                                            <textarea
                                                value={translations[lang.code]}
                                                onChange={(e) => handleTextChange(lang.code, e.target.value)}
                                                placeholder={`Enter announcement text in ${lang.label}...`}
                                                rows="3"
                                            />
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className="fullWidth saveBtn addAddress">
                                <button type="button" disabled={addBtnDis} onClick={onUpdateAnnouncement}>
                                    {loading ? langJson?.pleasewait ?? "Please wait..." : langJson?.savechanges ?? "Save Changes"}
                                </button>
                                <Link className="backLink" to="/admin/announcements">{langJson?.back ?? "Back"}</Link>
                            </div>
                        </>
                    )}
                </div>
            </div>
            <VendorFooter />
        </div>
    );
};

export default EditAnnouncement;
